import { render, staticRenderFns } from "./assets-detail.vue?vue&type=template&id=5c707c22&scoped=true"
import script from "./assets-detail.vue?vue&type=script&lang=js"
export * from "./assets-detail.vue?vue&type=script&lang=js"
import style0 from "./assets-detail.vue?vue&type=style&index=0&id=5c707c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c707c22",
  null
  
)

export default component.exports